import { Injectable, Injector } from '@angular/core';
import { Routes } from '@angular/router';
import { MenuItem, MenuItemRef, MenuService, RoutingService } from '@psei/ng';

@Injectable({
  providedIn: 'root'
})
export class PpbMenuServiceService extends MenuService {
  routing: RoutingService;
  constructor(injector: Injector, routing: RoutingService) {
    super(injector, routing);
  }

  activeMenuItemUpdate(container: MenuItemRef): void {
    super.activeMenuItemUpdate(container);
    // fix for single item menu entry, when active link has double // at the front and thus is not matched
    container.isActive = container.isActive
      || (container.activeRouterLink === '/' + container.item?.routerLink);
  }

  getMenuItems(routes: Routes = this.routing.router.config, parentRouterLink: string = ''): MenuItem[] {
    const menuRoutes = routes.find((route) => !!route.data?.afterLogin);

    return super.getMenuItems(menuRoutes ? menuRoutes.children : routes, parentRouterLink);
  }
}
